// extracted by mini-css-extract-plugin
export var buttonStyle = "prev_next_button-module--buttonStyle--MfY77";
export var isActiveStyle = "prev_next_button-module--isActiveStyle--O2+le";
export var isDisabledStyle = "prev_next_button-module--isDisabledStyle--XKPVE";
export var nextButtonStyle = "prev_next_button-module--nextButtonStyle--Q2cm5";
export var wrapperStyle = "prev_next_button-module--wrapperStyle---IP2u";